import React, { useState, useEffect } from 'react';
import './InternetConnectivityChecker.scss';

interface InternetConnectivityCheckerProps {
  children: React.ReactNode;
}

const InternetConnectivityChecker: React.FC<InternetConnectivityCheckerProps> = ({ children }) => {
  const [isOnline, setIsOnline] = useState<boolean>(navigator.onLine);

  useEffect(() => {
    const handleOnline = () => setIsOnline(true);
    const handleOffline = () => setIsOnline(false);

    window.addEventListener('online', handleOnline);
    window.addEventListener('offline', handleOffline);

    return () => {
      window.removeEventListener('online', handleOnline);
      window.removeEventListener('offline', handleOffline);
    };
  }, []);

  if (!isOnline) {
    return (
      <div className="internet-connectivity-warning">
        <div className="warning-content">
          <div className="warning-icon">
            <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 4C14.95 4 17.75 5.23 19.91 7.39C20.3 7.78 20.3 8.42 19.91 8.81L18.5 10.22C18.11 10.61 17.47 10.61 17.08 10.22C15.54 8.68 13.83 7.89 12 7.89C10.17 7.89 8.46 8.68 6.92 10.22C6.53 10.61 5.89 10.61 5.5 10.22L4.09 8.81C3.7 8.42 3.7 7.78 4.09 7.39C6.25 5.23 9.05 4 12 4Z" fill="currentColor"/>
              <path d="M12 10.9C13.32 10.9 14.62 11.45 15.53 12.36C15.92 12.75 15.92 13.39 15.53 13.78L14.12 15.19C13.73 15.58 13.09 15.58 12.7 15.19C12.31 14.8 11.69 14.8 11.3 15.19C10.91 15.58 10.27 15.58 9.88 15.19L8.47 13.78C8.08 13.39 8.08 12.75 8.47 12.36C9.38 11.45 10.68 10.9 12 10.9Z" fill="currentColor"/>
              <path d="M12 16C12.5523 16 13 16.4477 13 17C13 17.5523 12.5523 18 12 18C11.4477 18 11 17.5523 11 17C11 16.4477 11.4477 16 12 16Z" fill="currentColor"/>
            </svg>
          </div>
          <h2>No Internet Connection</h2>
          <p>Please check your internet connection and try again.</p>
          <button onClick={() => window.location.reload()} className="retry-button">
            Retry
          </button>
        </div>
      </div>
    );
  }

  return <>{children}</>;
};

export default InternetConnectivityChecker; 